import { message } from "antd";
import ClientRequests from "app/api/client";
import { handleGenericApiError } from "app/api/error";
import { I18n } from "react-redux-i18n";
import { addLoading, removeLoading } from "./loading";
import { UserActions } from ".";

export const ACTION_SAVE_CLIENTS = "client:ACTION_SAVE_CLIENTS";
export const ACTION_SAVE_CLIENT = "client:ACTION_SAVE_CLIENT";

export const fetchClients = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ClientRequests.fetchClients(params);
    dispatch({ type: ACTION_SAVE_CLIENTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchClientById = id => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ClientRequests.fetchClientById(id);
    dispatch({ type: ACTION_SAVE_CLIENT, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadClients = params => async () => {
  if (
    params.searchParameter?.InitialClientDate &&
    params.searchParameter?.EndClientDate
  ) {
    var initialDate = params.searchParameter?.InitialClientDate.split(" ");
    var endDate = params.searchParameter?.EndClientDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await ClientRequests.downloadClients(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "clientes.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const updateClientManualApprovalCaf =
  (id, callback) => async dispatch => {
    dispatch(addLoading());
    try {
      await ClientRequests.updateClientManualApprovalCaf(id);
      if (callback && typeof callback === "function") {
        callback();
      }
    } catch (err) {
      handleGenericApiError(err);
    } finally {
      dispatch(removeLoading());
    }
  };

export const updateClient = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ClientRequests.updateClient(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
    await dispatch(
      UserActions.fetchAllUserHistoric({
        document: data?.primaryDocument,
        origin: data?.origin,
      })
    );
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const disableClient = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ClientRequests.disableClient(id);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchClientIdByPrimaryDocument =
  primaryDocument => async dispatch => {
    dispatch(addLoading());

    try {
      const data =
        await ClientRequests.fetchClientIdByPrimaryDocument(primaryDocument);

      return data;
    } catch (err) {
      handleGenericApiError(err);

      return null;
    } finally {
      dispatch(removeLoading());
    }
  };
